import {
  AdminShareHorseData,
  BatchShareHorsesData,
  CreateHorseShareData,
  HorseShare,
  HorseShareActionResponseTypeEnum,
  HorseShareUpdate,
} from '@sleipai/sleip-models';
import { createAction, props } from '@ngrx/store';

export const loadHorseShareInfo = createAction(
  '[Horses-Share] Load Horse Share Info',
  props<{ groupId: string; horseId: string; userId?: string }>()
);

export const loadHorseShareInfoSuccess = createAction(
  '[Horses-Share] Load Horse Share Info Success',
  props<{ data: HorseShare }>()
);

export const loadHorseShareInfoFailure = createAction(
  '[Horses-Share] Load Horse Share Info Failure',
  props<{ error: any }>()
);

export const saveHorseShareInfo = createAction(
  '[Horses-Share] Save Horse Share Info',
  props<{ data: CreateHorseShareData }>()
);

// admin dashboard only
export const adminSaveHorseShareInfo = createAction(
  '[Horses-Share] Admin Save Horse Share Info',
  props<{ data: AdminShareHorseData }>()
);

export const stopHorseShare = createAction(
  '[Horses-Share] Stop Horse Share',
  props<{ data: HorseShareUpdate }>()
);

export const reactivateHorseShare = createAction(
  '[Horses-Share] Reactivate Horse Share',
  props<{ data: HorseShareUpdate }>()
);

export const saveHorseShareInfoSuccess = createAction(
  '[Horses-Share] Save Horse Share Info Success',
  props<{ horseShareActionResponseType: any }>()
);

export const saveHorseShareInfoFailure = createAction(
  '[Horses-Share] Save Horse Share Info Failure',
  props<{
    error: any;
    horseShareActionResponseType: HorseShareActionResponseTypeEnum;
  }>()
);

export const batchShareHorses = createAction(
  '[Horses-Share] Batch Share Horses',
  props<{ data: BatchShareHorsesData }>()
);

export const resetHorseSharedSavedFlag = createAction(
  '[Horses] Reset Horse Share Saved flag'
);
